"use client";

import { createContext } from "react";

import { CharlotteChatState } from "@/components/charlotte-chat/types";

export interface CharlotteChatContextValue {
  chatState: CharlotteChatState;
  close: () => void;
  iframeSrc: string;
  minimize: () => void;
  open: () => void;
}

export const CharlotteChatContext = createContext<
  CharlotteChatContextValue | undefined
>(undefined);
